import { graphql } from 'react-apollo'
import { ApplicationError, NotFoundError } from '../../helpers/errors'
import getImageFromEntry, { SQUARE } from '../../helpers/get-image-from-entry'
import showItem from '../../helpers/show-item-helper'
import getDescriptiveLocation from '../../helpers/get-descriptive-location'
import getStoreTitle from '../../helpers/get-store-title'
import { DateTime } from '../../helpers/date-helpers'
import { getOccurrences } from './../../helpers/occurrences'
import query from './query.graphql'

const mapPropsToOptions = ({ centre }) => {
  const templatePath = 'free-wifi'
  const centreId = centre && centre.sys.id

  return {
    errorPolicy: 'ignore',
    variables: {
      template: `fields.path=${templatePath}&fields.centres.sys.id=${centreId}`,
      centreId,
    },
    skip: Boolean(!centre),
  }
}

const mapDataToProps = ({
  data: { error, loading, templates, happenings },
  ownProps: { centre },
}) => {
  if (loading || !centre) {
    return { loading: true }
  } else if (error) {
    throw new ApplicationError(error)
  } else if (!templates[0]) {
    // The template is not valid
    return {
      error: new NotFoundError('Template not found.'),
    }
  } else if (!templates[0].modules[0]) {
    // The module is missing
    return {
      error: new NotFoundError('Required module missing.'),
    }
  } else if (!templates[0].modules[0].entries[0]) {
    // The entry is missing
    return {
      error: new NotFoundError('Required entry missing.'),
    }
  }
  const offer = templates[0].modules[0].entries[0]

  const now = DateTime.local({ timeZone: centre.timeZone })

  const allItems = [
    ...happenings.events,
    ...happenings.news,
    ...happenings.stories,
    ...happenings.offers,
  ]

  const items = allItems
    .sort((a, b) => new Date(b.sys.createdAt) - new Date(a.sys.createdAt))
    .reduce((tempItems, item) => {
      let hasOccurrence = false
      let occurrences = item.occurrences

      if (occurrences) {
        // Find the first occurrence where "now" is within startAt & stopAt (if any).
        hasOccurrence = occurrences.some(
          occurrence =>
            now >=
              DateTime.local(occurrence.startAt, {
                timeZone: centre.timeZone,
              }) &&
            now <
              DateTime.local(occurrence.endAt, { timeZone: centre.timeZone })
        )
      }

      // If we have an occurrence OR "now" falls within showAt and hideAt, we can then
      // add the item to our list of items.
      if (hasOccurrence || showItem(now, centre.timeZone, item)) {
        const image = getImageFromEntry(item, SQUARE)
        const category = item.__typename.toLowerCase()

        occurrences = getOccurrences(true, item, centre.timeZone)

        tempItems.push({
          link: `/${centre.slug}/${category}/${item.sys.id}/${item.slug}`,
          heading: item.title,
          category,
          body: item.shortDescription,
          image,
          occurrences,
          location: getDescriptiveLocation({
            level: item.level,
            physicalAddress: item.physicalAddress,
            hosted: item.hosted,
            storeTitle: getStoreTitle(centre, item),
          }),
          analyticsMetadata: item.analyticsMetadata,
        })
      }

      return tempItems
    }, [])

  return {
    template: templates[0],
    offer,
    store: offer.stores.find(store => store.centre.sys.id === centre.sys.id),
    items,
  }
}

const withWifiLanding = graphql(query, {
  options: mapPropsToOptions,
  props: mapDataToProps,
})

export default withWifiLanding
